import React from 'react';
import './CustomerLayout.scss';
import { Route } from 'react-router-dom';
import MenuTopContainer from 'Components/MenuTop/MenuTopContainer';
import MenuFooterContainer from 'Components/MenuFooter/MenuFooterContainer';
import BannerECommerceContainer from 'Components/BannerECommerce/BannerECommerceContainer';
import ScrollToTop from 'Components/Shared/ScrollToTop/ScrollToTop';

interface IProps {
  component: any
  path?: string;
  exact?: boolean;
}

const CustomerLayout: React.SFC<IProps> = ({ component: Component, ...rest }) => {
  return (
    <Route { ...rest } render={ matchProps => (
      <div className='customer-layout'>
        <ScrollToTop>
          <MenuTopContainer />
          <Component { ...matchProps } />
          <BannerECommerceContainer />
          <MenuFooterContainer />
        </ScrollToTop>
      </div>
    ) } />
  );
};

export default CustomerLayout;


// WEBPACK FOOTER //
// ./src/layouts/CustomerLayout/CustomerLayout.tsx